<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @exportData="exportData"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openAdd="addFormDialogVisible = true"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <AddForm
      ref="addForm"
      :visible.sync="addFormDialogVisible"
      @reload="reload"
    />
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: {
          hxShipmentJdCode: chooseTemplateOptions.hxShipmentJdCode,
        },
        checkUrl: chooseTemplateOptions.checkUrl,
      }"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import AddForm from '../add-form'
import ChooseTemplate from '@/views/ecom/components/choose-template'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageHeader, PageMain, AddForm, ChooseTemplate },
  data() {
    return {
      usePage: true,
      addFormDialogVisible: false,
      chooseTemplateOptions: {
        visible: false,
        hxShipmentJdCode: '',
        templateGroup: '',
        checkUrl: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomHxShipmentJdListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-hxBiz-jdShipment-detail',
        params: { ...params, pageType },
        query,
      })
    },
    exportData({ menuType, hxShipmentJdCode }) {
      if (!hxShipmentJdCode) return
      if (menuType == 'packinglist') {
        this.chooseTemplateOptions = {
          visible: true,
          hxShipmentJdCode,
          templateGroup: 'ecom-hxShipmentJdVehicleOrder',
          checkUrl: '/ecom/hx/shipment/jd/export/check',
        }
      } else if (menuType == 'shipmentlist') {
        this.chooseTemplateOptions = {
          visible: true,
          hxShipmentJdCode,
          templateGroup: 'ecom-hxShipmentJdOrderShipping',
        }
      } else {
        this.chooseTemplateOptions = {
          visible: true,
          hxShipmentJdCode,
          templateGroup: 'ecom-hxShipmentJdOrderDcLabel',
        }
      }
    },
  },
}
</script>
